import React from 'react';
import TarjetasTable from './TarjetasTable';
import NuevaTarjetaForm from './NuevaTarjetaForm';
import { Link } from 'react-router-dom';
import Dialog from 'rc-dialog';
import 'rc-dialog/assets/bootstrap.css';
import { GenericAlert } from 'com-gyf-webcore-userinterfacecomponents';
import { Redirect } from 'react-router-dom';
import ProcessManager from '../../../Common/Managers/ProcessManager';

//Mensaje de error que se muestra cuando no se completan los datos para realizar el alta...
const Alerta = (props) => {
    if (props.mostrarError) {
        return <GenericAlert message="Por favor, recuerde que debe seleccionar todos los campos antes de agregar una tarjeta y poder finalizar el proceso o presione “Cancelar” para volver a la pantalla anterior." type="warning" />;
    } else {
        return null;
    }
}
let motrarForNuevaTarjeta = 0;
class NuevaSolicitudDatos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            responsableTarjeta: null,
            domicilioResponsable: null,
            errorDialogVisible: false,
            errorDobleTarjeta: false
        };
    }

    componentDidMount() {
        let cuenta = this.props.plasticos.cuentasDelivery.find(x => x.CodigoCuenta == this.props.match.params.id);
        let poseeTarjetas = false;
        if (this.props.plasticos.tarjetas.length > 0)
            poseeTarjetas = true;

        this.props.getScreenData(this.props.routeState, this.props.currentScope, cuenta, poseeTarjetas, this.props.login);
    }

    onClose() {
        this.setState({ errorDialogVisible: false });
    }

    componentWillUnmount() {
        this.props.reiniciarEstado();
    }

    ocultarModalRepetTarjeta() {
        this.setState({ errorDobleTarjeta: !this.state.errorDobleTarjeta })
    }

    agregarTarjetas(tarjeta) {

        let tarjetas = this.props.plasticos.tarjetas.find( x => ( x.idProducto == tarjeta.ProductoId || x.ProductoId == tarjeta.ProductoId ) && x.NumeroDocumento == this.ValueCuil( tarjeta.NumeroDocumento ) );
        let solicitudes = this.props.plasticos.solicitudes.find( x => ( x.Col1 == 120002 || x.Col1 == 120001 ) && ( x.Estado.toLowerCase() !== 'o' || x.Estado.toLowerCase() === 'e' ) && x.Col49.substr( 1 ) === this.ValueCuil( tarjeta.NumeroDocumento ) && x.NumeroCuenta.toString() === tarjeta.NumeroCuenta );

        if ( solicitudes != undefined || tarjetas != undefined ) {
            this.setState( { errorDobleTarjeta: true } )
        } else {
            this.props.addTarjeta( tarjeta )
        }

    }

    guardarSolicitud() {
        let Guardar = false;
        this.props.plasticos.tarjetas.forEach(function (item) {
            if (item.key !== undefined) {
                Guardar = true;
            }
        });

        if (Guardar) {
            this.props.preGuardarSolicitud(this.props.plasticos.tarjetas, this.props.plasticos.clienteResultadoBusqueda, this.props.data, this.props.plasticos)
        } else {

        }
        
    }

    ValueCuil(value) {
        if (value.length == 11) {
            value = value.slice(2, -1);
        }
        return value;
    }
    render() {

        let clienteTipoPersona;

        if (this.props.data.todoOk)
            return <Redirect to={ProcessManager.GetNextStep("NuevaSolicitud", "ROUTE_TO_SELECCIONAR_CUENTA")} push />



        if (this.props.plasticos !== undefined) {
            if (this.props.plasticos.dataUsuario !== undefined && this.props.plasticos.dataUsuario.FisicaJuridica === 'J') {
                clienteTipoPersona = <span className="ti-user portico client-search-icon color-persona-fisica" aria-hidden="true"></span>;
            } else {
                clienteTipoPersona = <span className="ti-user portico client-search-icon color-persona-juridica" aria-hidden="true"></span>;
            }

            let tabla; let cuentaPoseePlasticos = false; let CantTarjetas = 0;

            if (this.props.data.cuentaSeleccionada != undefined) {
                var tarj = this.props.plasticos.tarjetas.find(x => x.NumeroCuenta == this.props.data.cuentaSeleccionada.CodigoCuenta);
                
            }


            if (this.props.plasticos.dataUsuario !== undefined && tarj != undefined && this.props.data.cuentaSeleccionada !== undefined) {
                motrarForNuevaTarjeta = 0;
                tabla = <div className="NuevaSolicitudTabla"><TarjetasTable tarjetasData={this.props.plasticos.tarjetas} solicitudes={this.props.plasticos.solicitudes} removeTarjeta={this.props.removeTarjeta} nroCuenta={this.props.data.cuentaSeleccionada.CodigoCuenta} nombreCliente={this.props.plasticos.dataUsuario.usuarioActual} productosIbs={this.props.data.productosIbs} limites={this.props.data.limites } /></div>;
                cuentaPoseePlasticos = true;
            } else {
                tabla = <div style={{ width: '749px' }}><GenericAlert message="La cuenta no posee tarjetas asociadas. Recuerde que el 'Titular Principal' debe tener una tarjeta para poder gestionar otras." type="warning" /></div>;
                motrarForNuevaTarjeta = 1;
            }

            if (this.props.data.responsables != undefined){
                if (cuentaPoseePlasticos) {
                    motrarForNuevaTarjeta = 0;
                    this.props.data.responsables.forEach(function (item) {
                        if (item.CliVinCod != 0) {
                            if (item.PoseeTarjetas != true) {
                                motrarForNuevaTarjeta++
                            }
                        }
                    });
                } else {
                    motrarForNuevaTarjeta = 1;
                }
               
                
            }

            if (this.props.data && this.props.plasticos.dataUsuario) {
                return (

                    <div>

                        <div className="NuevaSolicitudTitle">
                            <h1>
                                Nueva solicitud de {this.props.plasticos.dataUsuario.usuarioActual}
                            </h1>
                            <span>
                                {clienteTipoPersona}
                                <label className="label-secondary label-cuit">
                                    CUIL &nbsp;
                            {this.props.plasticos.dataUsuario.cuil}
                                </label>
                            </span>
                        </div>

                        <Alerta mostrarError={this.props.data.error} />

                        <div className="TarjetasCuentaTitle">
                            <h3>Tarjetas de la cuenta <strong>Nº {this.props.data.cuentaSeleccionada != undefined ? this.props.data.cuentaSeleccionada.CodigoCuenta : ""}</strong></h3>
                        </div>

                        {tabla}


                        <div>
                            { motrarForNuevaTarjeta > 0 ?
                                <NuevaTarjetaForm
                                    tarjetasData={this.props.plasticos.tarjetas}
                                    data={this.props.data}
                                    plasticos={this.props.plasticos}
                                    responsableTarjeta={this.state.responsableTarjeta}
                                    domicilioResponsable={this.state.domicilioResponsable}
                                    changeResponsable={this.props.changeResponsable.bind(this)}
                                    changeDomicilio={this.props.changeDomicilio.bind(this)}
                                    addTarjeta={(tarjeta) => this.agregarTarjetas(tarjeta)}
                                    showError={this.props.showError}
                                    changeLimite={this.props.changeLimite}
                                    changeProductoIbs={this.props.changeProductoIbs}
                                    cuentaPoseePlasticos={cuentaPoseePlasticos}
                                /> : <div className="nuevasolicitud-form-alta"><h1> Todos los reponsables tienen una tarjeta. </h1></div>
                                
                            }
                        </div>

                        <div className="NuevaSolicitudConfirmar">
                            <button className="btn btn-cta bto-finalizar-solicitud" onClick={(event) => this.guardarSolicitud()}>Finalizar solicitud</button>
                            <Link to="/TARJETAS/Socios/SOCIOS/VistaCliente"><button className="btn btn-secondary">Cancelar</button></Link>

                        </div>

                        <div>
                            <Dialog
                                visible={this.state.errorDialogVisible}
                                onClose={this.onClose.bind(this)}
                                animation="slide-fade"
                                maskAnimation="fade"
                                style={{ width: 600 }}
                                title=" Nueva Solicitud"
                                footer={
                                    [
                                        <button
                                            type="button"
                                            className="btn btn-default"
                                            key="close"
                                            onClick={this.onClose.bind(this)}
                                        >
                                            Cerrar
                                    </button>
                                    ]
                                }
                            >
                                Debe completar todos los campos antes de poder agregar una tarjeta.
             Por favor, verifique que los mismos no esten vacíos.
          </Dialog>
                        </div>

                        {/*Modal*/}
                        <Dialog
                            visible={this.state.errorDobleTarjeta}
                            onClose={() => this.ocultarModalRepetTarjeta(this.state.errorDobleTarjeta)}
                            animation="slide-fade"
                            maskAnimation="fade"
                            style={{ width: 600 }}
                            title={"Atenci" + String.fromCharCode(243) + "n"}
                            footer={[<button type="button" className="btn btn-default" key="close" onClick={() => this.ocultarModalRepetTarjeta(this.state.errorDobleTarjeta)}>
                                Cerrar
                            </button>
                            ]}>
                            <p>Ya se encuentra una tarjeta activa y/o en trámite para el responsable seleccionado.</p>
                        </Dialog>
                    </div>
                );
            } else {
                return null;
            }
        }
    }

}

export default NuevaSolicitudDatos;
